import { Row } from "antd";
import { YearsFormItem } from "./YearsFormItem";
import { Footer } from "./Footer";
import { useState } from "react";
import { IPrintRequest } from "../../../types";
import { usePrint } from "./hooks/usePrint";

type FormItemsProps = {
  years: number[];
  accountNumber: number;
  cancel: () => void;
};

export const FormItems = ({ years, accountNumber, cancel }: FormItemsProps) => {
  const [request, setRequest] = useState<IPrintRequest>({
    year: years[0],
  });

  const { isLoading, print } = usePrint(request, accountNumber, cancel);

  return (
    <>
      <Row className="w-100 justify-space-around form-container pr-6 overflow-y-auto">
        <Row className="pt-4 w-100">
          <YearsFormItem
            years={years}
            isLoading={isLoading}
            request={request}
            setRequest={setRequest}
          />
        </Row>
      </Row>
      <Footer isLoading={isLoading} print={print} cancel={cancel} />
    </>
  );
};
